import { local_storage, LOCALSTORAGE_OPTIONS, localStorageKey } from '@/store/lib/local_storage';
import { SIDEBAR_TYPE_NOTIFICATIONS } from '@/app/data/general_constants';

function sidebarPrefsFromStorage(key, key_legacy, prefs_default) {
  const prefs_storage = key ? local_storage.get(key) : {};
  if (!_.isEmpty(prefs_storage) || !key_legacy) {
    return { ...prefs_default, ...prefs_storage };
  }

  const prefs_legacy = local_storage.get(key_legacy);
  return { ...prefs_default, ...prefs_legacy };
}

const state = {
  sidebar_prefs: {
    page: 1,
    is_pinned: false,
    sidebar_width: 450,
  },
  sidebar_type: null,
};

const actions = {
  INIT_SIDEBAR_PREFS({ commit, getters }) {
    const key = getters.local_storage_key;
    const key_legacy = getters.local_storage_key_legacy;
    const default_sidebar_prefs = getters.sidebar_prefs;
    if (!key) {
      // e.g. necessary when employee impersonates a customer
      commit('SET_SIDEBAR_PREFS', default_sidebar_prefs);
    } else {
      const sidebar_prefs = sidebarPrefsFromStorage(key, key_legacy, default_sidebar_prefs);
      commit('SET_SIDEBAR_PREFS', sidebar_prefs);
      local_storage.set(key, sidebar_prefs);
    }
    if (getters.sidebar_prefs.is_pinned) {
      commit('SET_SIDEBAR_TYPE', SIDEBAR_TYPE_NOTIFICATIONS);
    }
  },

  UPDATE_SIDEBAR_PREFS({ commit, getters }, sidebar_prefs) {
    const attributes = { ...getters.sidebar_prefs, ...sidebar_prefs };
    commit('SET_SIDEBAR_PREFS', attributes);
    if (getters.local_storage_key) local_storage.set(getters.local_storage_key, getters.sidebar_prefs);
  },

  SHOW_SIDEBAR({ commit }, type) {
    commit('SET_SIDEBAR_TYPE', type);
  },
};

const mutations = {
  SET_SIDEBAR_PREFS(state, sidebar_prefs) {
    state.sidebar_prefs = sidebar_prefs;
  },

  SET_SIDEBAR_TYPE(state, type) {
    state.sidebar_type = type;
  },
};

const getters = {
  sidebar_prefs: (state) => state.sidebar_prefs,
  sidebar_type: (state) => state.sidebar_type,
  local_storage_key: (_state, _getters, rootState) => {
    const { current_profile } = rootState.shared.current;
    return localStorageKey(current_profile, LOCALSTORAGE_OPTIONS.NOTIFICATIONS_SIDEBAR);
  },
  local_storage_key_legacy: (_state, _getters, rootState) => {
    const { current_profile } = rootState.shared.current;
    return localStorageKey(current_profile, LOCALSTORAGE_OPTIONS.SIDEBAR);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
